import ApiClient from '../plugins/AxiosPlugin'

const URL = '/.dow.geolocation.info.json'

/* Shared with corp as it uses this cache name */
const CACHE_KEY = 'locationContext'

const REQUEST_TIMEOUT_MS = 5000

/* Location fields */
const FIELDS = ['city', 'continent', 'country_code', 'region_code']

/* Fallback for a sessionStorage that throws or is blocked. */
let memory = null

/* sessionStorage is not written until the response resolves, so without this
   callers in the same tick would each fire their own request. */
let inFlight = null

function project(data) {
    return FIELDS.reduce((projected, field) => {
        if (data && data[field] !== undefined) projected[field] = data[field]
        return projected
    }, {})
}

function writeCache(data) {
    try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(data))
    } catch (error) {
        /* Private window or blocked site data; `memory` carries the value. */
    }
}

function readCachedLocation() {
    if (memory) return memory
    try {
        const raw = sessionStorage.getItem(CACHE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}

/**
 * Resolves the visitor's location, at most once per session. All callers use this to resolve location.
 * A failed request is not cached, so a later caller retries.
 */
export async function findLocation() {
    const cached = readCachedLocation()
    if (cached) return cached

    if (inFlight) return inFlight

    inFlight = ApiClient.get(URL, { timeout: REQUEST_TIMEOUT_MS })
        .then((res) => {
            const data = project(res.data)
            memory = data
            writeCache(data)
            return data
        })
        .finally(() => {
            inFlight = null
        })

    return inFlight
}
